import { showNotification } from 'SourceStore/Notification/Notification.action';
import { QueryDispatcher } from 'SourceUtil/Request';
import { sampleProductList, updateIsLoading } from './SampleProduct.action';
import SampleProductsQuery from '../../query/SampleProductsQuery.query'
/**
 * RelatedProducts Dispatcher
 * @class RelatedProductsDispatcher
 * @extends QueryDispatcher
 * @namespace Store/SampleProducts/Dispatcher
 */
export class SampleProductsDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('sampleProducts');
    }
    onSuccess({ getSampleProductCollection }, dispatch) {
        
        this.dispatchSampleProductList(dispatch, getSampleProductCollection);
    }

    dispatchSampleProductList (dispatch, ProductListing) {
        dispatch(sampleProductList(ProductListing));
        dispatch(updateIsLoading(false));
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', __('Error fetching sample products list!'), error));
    }

    /**
     * Prepare relatedProducts query
     * @return {Query} RelatedProducts query
     * @memberof relatedProductsProductsDispatcher
     * @param relatedProducts
     */
    prepareRequest(options, dispatch) {
        if(Object.values(options?.in).length > 0) {
            dispatch(updateIsLoading(true));
            return [
                SampleProductsQuery.getSampleProductQuery(options)
            ];
        }
        dispatch(sampleProductList([]));
    }
}

export default new SampleProductsDispatcher();